/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PamPlayerStatus } from './PamPlayerStatus';
import {
    PamPlayerStatusFromJSON,
    PamPlayerStatusFromJSONTyped,
    PamPlayerStatusToJSON,
} from './PamPlayerStatus';
import type { PamPlayerVerificationStatus } from './PamPlayerVerificationStatus';
import {
    PamPlayerVerificationStatusFromJSON,
    PamPlayerVerificationStatusFromJSONTyped,
    PamPlayerVerificationStatusToJSON,
} from './PamPlayerVerificationStatus';

/**
 * A PAM player row in the back-office search results. Name + email are denormalized on
 * pam_player; the row is navigable to details via lookupId. verificationStatus is absent
 * for a player who never started KYC.
 * @export
 * @interface PamPlayerSearchSummary
 */
export interface PamPlayerSearchSummary {
    /**
     * 
     * @type {PamPlayerVerificationStatus}
     * @memberof PamPlayerSearchSummary
     */
    verificationStatus?: PamPlayerVerificationStatus | null;
    /**
     * 
     * @type {PamPlayerStatus}
     * @memberof PamPlayerSearchSummary
     */
    status: PamPlayerStatus;
    /**
     * 
     * @type {string}
     * @memberof PamPlayerSearchSummary
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof PamPlayerSearchSummary
     */
    lastName: string | null;
    /**
     * 
     * @type {string}
     * @memberof PamPlayerSearchSummary
     */
    firstName: string | null;
    /**
     * 
     * @type {string}
     * @memberof PamPlayerSearchSummary
     */
    lookupId: string;
}



/**
 * Check if a given object implements the PamPlayerSearchSummary interface.
 */
export function instanceOfPamPlayerSearchSummary(value: object): value is PamPlayerSearchSummary {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lookupId' in value) || value['lookupId'] === undefined) return false;
    return true;
}

export function PamPlayerSearchSummaryFromJSON(json: any): PamPlayerSearchSummary {
    return PamPlayerSearchSummaryFromJSONTyped(json, false);
}

export function PamPlayerSearchSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PamPlayerSearchSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'verificationStatus': json['verificationStatus'] == null ? undefined : PamPlayerVerificationStatusFromJSON(json['verificationStatus']),
        'status': PamPlayerStatusFromJSON(json['status']),
        'email': json['email'],
        'lastName': json['lastName'],
        'firstName': json['firstName'],
        'lookupId': json['lookupId'],
    };
}

export function PamPlayerSearchSummaryToJSON(value?: PamPlayerSearchSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'verificationStatus': PamPlayerVerificationStatusToJSON(value['verificationStatus']),
        'status': PamPlayerStatusToJSON(value['status']),
        'email': value['email'],
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'lookupId': value['lookupId'],
    };
}

